import { createSlice } from "@reduxjs/toolkit";
import * as UserApi from "../api/user";

const users = createSlice({
  name: "users",
  initialState: {
    loading: false,
    error: null,
    list: [],
    summary: null,
    roleStats: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getListSuccess: (state, action) => {
      state.summary = action.payload.summary;
      state.list = action.payload.docs;
      state.roleStats = action.payload.roleStats;
      state.loading = false;
    },
    updateUserSuccess: (state, action) => {
      state.list = state.list.map((user) => {
        if (user._id === action.payload._id) {
          return action.payload;
        } else {
          return user;
        }
      });
    },
    deleteUserSuccess: (state, action) => {
      state.list = state.list.filter(
        (item) => action.payload?._id !== item._id
      );
    },
  },
});

export const getListUser = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await UserApi.getListUser(params);
    dispatch(getListSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = users;
export const {
  setLoading,
  setError,
  getListSuccess,
  updateUserSuccess,
  deleteUserSuccess,
} = actions;
export default reducer;
